"use client";

import { ArrowUp } from "lucide-react";
import { motion, useReducedMotion } from "framer-motion";
import { useScrollContext } from "@/components/motion/SmoothScrollProvider";

export function FooterBackToTop() {
  const { scrollToTop } = useScrollContext();
  const reduced = useReducedMotion();

  return (
    <motion.button
      type="button"
      onClick={scrollToTop}
      whileHover={reduced ? undefined : { scale: 1.06 }}
      whileTap={reduced ? undefined : { scale: 0.96 }}
      transition={{ duration: 0.15, ease: [0.22, 1, 0.36, 1] }}
      className="footer-back-to-top group inline-flex items-center gap-2 text-sm text-muted transition-colors hover:text-accent"
      aria-label="Back to top"
    >
      <span className="hidden sm:inline">Back to Top</span>
      <span className="footer-back-to-top-icon flex h-9 w-9 items-center justify-center rounded-full border transition-colors group-hover:border-accent group-hover:bg-accent/10">
        <ArrowUp size={16} aria-hidden />
      </span>
    </motion.button>
  );
}
